import React, {useState,useEffect}  from 'react'
import './homeslider.css'
import scroll1 from '../img/scroll/scroll1.png';
import scroll2 from '../img/scroll/scroll2.png';
import scroll3 from '../img/scroll/scroll3.png';
import scroll4 from '../img/scroll/scroll4.png';
import scroll5 from '../img/scroll/scroll5.png';
import scroll6 from '../img/scroll/scroll6.png';
import scroll7 from '../img/scroll/scroll7.png';


const Homeslider1 = () => {
  const images = [scroll7,scroll1, scroll4, scroll2,scroll5,scroll3,scroll6,];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [images.length]);


  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };
  return (
    <div className="carousel">
      <button className="carousel-btn prev" onClick={handlePrev}>
        &#8249;
      </button>
      <div className="carousel-image-wrapper">
        <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="carousel-image" />
      </div>
      <button className="carousel-btn next" onClick={handleNext}>
        &#8250;
      </button>
      <div className="carousel-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  )
}

export default Homeslider1